import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Login from "../pages/login/page";
import Dashboard from "../pages/dashboard/page";
import Transactions from "../pages/transactions/page";
import Settings from "../pages/settings/page";
import ApiDocs from "../pages/api-docs/page";
import Withdraw from "../pages/withdraw/page";
import MerchantKeys from "../pages/merchant-keys/page";
import PaymentAccounts from "../pages/payment-accounts/page";
import Channels from "../pages/channels/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/transactions",
    element: <Transactions />,
  },
  {
    path: "/channels",
    element: <Channels />,
  },
  {
    path: "/settings",
    element: <Settings />,
  },
  {
    path: "/api-docs",
    element: <ApiDocs />,
  },
  {
    path: "/withdraw",
    element: <Withdraw />,
  },
  {
    path: "/payment-accounts",
    element: <PaymentAccounts />,
  },
  {
    path: "/merchant-keys",
    element: <MerchantKeys />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
